<script setup lang="ts">
import type { WithClassAsProps } from '@/components/lib/shadcn-vue/carousel/interface';
import { useCarousel } from '@/components/lib/shadcn-vue/carousel/useCarousel';
import { cn } from '@/components/lib/shadcn-vue/utils';

const props = defineProps<WithClassAsProps>();

const { orientation } = useCarousel();
</script>

<template>
  <div aria-roledescription="slide" role="group" :class="cn('min-w-0 shrink-0 grow-0 basis-full', orientation === 'horizontal' ? 'pl-0' : 'pt-4', props.class)">
    <slot />
  </div>
</template>
